export default {
  default: {
    checkboxValueYes: 'Yes',
    checkboxValueNo: 'No',
    optionValue: 'Please Select...',
  },
}
